import { RpcService } from 'rpc';

export interface AttemptData {
	completed: string;
	score: string;
	correct?: number;
	total?: number;
	id?: string;
	selected?: boolean;
	value?: string | null;
}

export interface AttemptQuiz {
	qid: string;
	title: string;
	kind: string;
	attempts: AttemptData[];
}

export interface BestScore {
	quiz_id: string;
	quiz_title: string;
	report_title: string;
	attempts: string | null;
	score: AttemptData;
}

export type SelectObj = Record<string, any>;

export interface ReportsSvc extends RpcService {
	module_best(params: {
		member_id: string;
		product_id?: string;
		session_id?: number;
		lp?: string;
		site?: string;
		select?: SelectObj;
	}): Promise<BestScore[]>;

	attempts_quizzes(params: {
		quiz_type: string;
		member_id: string;
		product_id?: string;
		session_id?: number;
		lp?: string;
		site?: string;
		select?: SelectObj;
	}): Promise<AttemptQuiz[]>;
}

export const svc: ReportsSvc = new RpcService({
	transport: 'WEBSOCKET',
	envelope: 'JSON-RPC-2.0',
	strictParameters: false,
	target: `${window.hcstatic.portal_url}/reports/@@individual.rpc`,

	services: {
		module_best: {
			parameters: [
				{ name: 'member_id', type: 'string', optional: false },
				{ name: 'product_id', type: 'string', optional: true },
				{ name: 'session_id', type: 'integer', optional: true },
				{ name: 'lp', type: 'string', optional: true },
				{ name: 'site', type: 'string', optional: true },
				{ name: 'select', type: 'object', optional: true }
			]
		},

		attempts_quizzes: {
			parameters: [
				{ name: 'quiz_type', type: 'string', optional: false },
				{ name: 'member_id', type: 'string', optional: false },
				{ name: 'product_id', type: 'string', optional: true },
				{ name: 'session_id', type: 'integer', optional: true },
				{ name: 'lp', type: 'string', optional: true },
				{ name: 'site', type: 'string', optional: true },
				{ name: 'select', type: 'object', optional: true }
			]
		}
	}
}) as ReportsSvc;

export default svc;
